import React from 'react';
import { AllieColors } from '../../../../common/color.types';
import { AllieText, TextType } from '../../../Text';
import { DataGridCellBaseProps } from '../../DataGridCell.types';

export type DataGridTextCellProps = {
  textType?: TextType;
  weight?: 300 | 400 | 500 | 600;
  color?: AllieColors
};
export const DataGridTextCell: React.FC<
  DataGridCellBaseProps<string, DataGridTextCellProps>
> = ({ value, cellProps }) => {
  return (
    <AllieText type={cellProps.textType} style={{ fontWeight: cellProps.weight }} color={cellProps.color}>
      {value}
    </AllieText>
  );
};
